import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';

class UserRenderIndividualRoadmap extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            propsData: {
                certificationParticipationId: '',
                levelId:'',
                trackId:''
            },
        	data: {
        		levelName: ''
        	},
        	roadmapDetails: []
    	};
    }

    handleRMView = (e, topicName, topicId) => {
        this.props.onhandleRMView(this.props.levelId, this.props.levelName, this.props.trackId, this.props.trackName, topicName, topicId, this.props.certificationParticipationId)
    }

    componentDidMount() {
    	let roadmapDetails = Object.assign({}, this.state.roadmapDetails)
        let propsData = Object.assign({}, this.state.propsData)
        propsData.certificationParticipationId = this.props.certificationParticipationId
        propsData.levelId = this.props.levelId
        propsData.trackId = this.props.trackId
        this.setState({propsData: propsData})
    	return api.userRenderIndividualRoadmap(this.props.user.accessToken, this.props.certificationParticipationId)
    	.then((result) => {
    		roadmapDetails = result.data
    		this.setState({roadmapDetails: roadmapDetails})
    	})
    }

    render() {
    	let individualComponent
        let handleRMView = this.handleRMView
    	if (this.state.roadmapDetails.length > 0) {
    		individualComponent = (
    			<Grid>
    				{this.state.roadmapDetails.map(function(individualRoadmap){
                        let topicId = individualRoadmap.topic_id
                        let topicName = individualRoadmap.topic_name
                        return(
    					<GridCell span="6">
    						<Card style={{padding: '5px'}}>
                                <Grid>
                                    <GridCell span="9">
                                        <Typography> {topicName} </Typography>
                                    </GridCell>
                                    <GridCell span="3">
                                        <button className="mdc-button" align = "right" aria-label="Favorite" onClick= {((e) => handleRMView(e, topicName, topicId))}>
                                            View
                                        </button>
                                    </GridCell>
                                </Grid>
    						</Card>
    					</GridCell>
                        )
    				})}
    			</Grid>
    		)
    	}
    	return (
          		<GridCell span="12">
            		<Card style={{padding: '25px'}} className='card-background-color'>
                        <Typography use="subtitle1"> Your MC Registration Details are: </Typography>
                		<Typography use="subtitle1"> <b>Level: </b> {this.props.levelName} </Typography>
                		<Typography use="subtitle1"> <b>Track: </b> {this.props.trackName} </Typography>
              		</Card>
                    {individualComponent}
              	</GridCell>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRenderIndividualRoadmap);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserRenderIndividualRoadmap.jsx